import PRINTER from '../../../api/printer';

const state = {
  loading: false,
  templates: [],
};

const actions = {
  print({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      PRINTER.print(data).then(response => {
        let link = document.createElement('a');
        link.download = 'download';
        link.href = response.data.url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        delete this.link;
        resolve(response);

      }).catch(error => {
        reject(error);
      }).finally(function () {

      });
    });
  },
  preview({ dispatch }, data) {
    return new Promise((resolve, reject) => {
      PRINTER.preview(data).then(response => {
        return resolve(response);
      }).catch(error => {
        reject(error);
      }).finally(function () {

      });
    });
  },
  loadTemplates({ commit, dispatch }, data) {
    commit('setLoading', true);
    return PRINTER.loadTemplates(data)
      .then(({ data }) => {
        commit('setTemplates', data);
      })
      .finally(() => {
        commit('setLoading', false);
      });
  },
};

const mutations = {
  setLoading(state, value) {
    state.loading = value;
  },
  setTemplates(state, data) {
    state.templates = data;
  },
  setShouldRender(state, [index, value]) {
    state.templates[index].shouldRender = value;
  },
};


export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
